import { defaultHttpClient } from '../../httpClient';
import type {
  PostKakaoAccessTokenRequest,
  PostKakaoAccessTokenResponse,
} from './types';

/**
 * - 카카오 OAuth 인가 코드(authorization code)를 카카오 access_token으로 교환하는 API
 * - 코드 교환은 백엔드가 대행한다.
 */
export const postKakaoAccessToken = (params: PostKakaoAccessTokenRequest) => {
  return defaultHttpClient
    .request<PostKakaoAccessTokenResponse>({
      method: 'POST',
      url: '/api/v2/login/kakao/access-token',
      data: params,
    })
    .then(result => result.data);
};
